import { Button, ButtonProps } from '@coolblue-development/freddy';
import styled from '@emotion/styled';
import { ComponentProps } from 'react';

const StyledShoppingCartButton = styled(Button)<
  ButtonProps & ComponentProps<'a'> & { component: string }
>(({ theme }) => ({
  [theme.breakpoint.minWidth('md')]: {
    maxWidth: '25rem'
  }
}));

export default StyledShoppingCartButton;
